export const male_hands = [ //An array of each Male Hand's ID and Name. There are 2.
  {
    id: 'hand2',
    name: 'Open hands'
  },
  {
    id: 'hand4',
    name: 'Closed hands'
  },
]